import noticeStore from '@components/LocalMerchant/NoticeChat/store'
import { MARKETING_CENTER_PATH } from '@constant'
import { RouterView } from '@merchant-backend/common-components'
import { isUltimate } from '@merchant-backend/util'
import { getProTitle } from '@util'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import { Link } from 'react-router'
import Header from './Header'
import NoProContent from './NoProContent'
import ProContent from './ProContent'
import Store from './store'
import VideoModal from './VideoModal'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
    this.store.init()
  }

  componentWillUnmount() {
    noticeStore.setBottom()
  }

  render() {
    const { loading, pay_money } = this.store
    const { fee } = pay_money
    const _isUltimate = isUltimate()

    return (
      <RouterView
        header={[
          <Link to={MARKETING_CENTER_PATH}>服务市场</Link>,
          getProTitle()
        ]}
        title={getProTitle()}
        viewStyle={{ marginBottom: !_isUltimate && fee ? '120px' : '20px' }}
      >
        {!loading && (
          <div>
            <Header store={this.store} />
            {!_isUltimate && <NoProContent store={this.store} />}
            {_isUltimate && <ProContent store={this.store} />}
            <VideoModal store={this.store} />
          </div>
        )}
      </RouterView>
    )
  }
}
